"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var StringService = require("@cloudbreakus/stringify");
var _require = require("../constants/loggingLevels"),
  INFO = _require.INFO,
  WARNING = _require.WARNING,
  ERROR = _require.ERROR,
  DEBUG = _require.DEBUG;
var MessagePresenter = /*#__PURE__*/function () {
  function MessagePresenter() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, MessagePresenter);
    (0, _defineProperty2["default"])(this, "_buildAttributes", function (_attributes) {
      var attributes = [StringService.format(new Date().toISOString(), StringService.HANDLERS.TIMESTAMP)];
      if (_attributes !== null && _attributes !== void 0 && _attributes.length) {
        attributes.push.apply(attributes, (0, _toConsumableArray2["default"])(_attributes.map(function (_ref) {
          var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];
          return "".concat(key, "=").concat(val);
        })));
      }
      return "[".concat(attributes.join(" "), "]");
    });
    (0, _defineProperty2["default"])(this, "_buildBaseMessage", function (msg) {
      return "".concat(_this._buildAttributes(), " ").concat(msg);
    });
  }
  return (0, _createClass2["default"])(MessagePresenter, [{
    key: "_buildStringFromError",
    value: function _buildStringFromError(error) {
      var _error$name, _error$stack;
      return "".concat((_error$name = error === null || error === void 0 ? void 0 : error.name) !== null && _error$name !== void 0 ? _error$name : "UnknownError", "-").concat(error.message, "/").concat((_error$stack = error === null || error === void 0 ? void 0 : error.stack) !== null && _error$stack !== void 0 ? _error$stack : "");
    }
  }, {
    key: "_buildPayloadIntoString",
    value: function _buildPayloadIntoString() {
      var str = "";
      for (var _len = arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++) {
        payload[_key] = arguments[_key];
      }
      for (var _i = 0, _payload = payload; _i < _payload.length; _i++) {
        var log = _payload[_i];
        var separator = !str ? "" : "\n";
        var base = "".concat(str).concat(separator);
        str = log instanceof Error ? "".concat(base).concat(this._buildStringFromError(log)) : (0, _typeof2["default"])(log) === "object" ? "".concat(base).concat(JSON.stringify(log)) : "".concat(base).concat(log);
      }
      return str;
    }
  }, {
    key: "buildInfoMessage",
    value: function buildInfoMessage(message) {
      return this._buildBaseMessage("".concat(INFO, ":").concat(message));
    }
  }, {
    key: "buildDebugMessage",
    value: function buildDebugMessage(message) {
      return this._buildBaseMessage("".concat(DEBUG, ":").concat(message));
    }
  }, {
    key: "buildWarningMessage",
    value: function buildWarningMessage(message) {
      return this._buildBaseMessage("".concat(WARNING, ":").concat(message));
    }
  }, {
    key: "buildErrorMessage",
    value: function buildErrorMessage(error) {
      return error instanceof Error ? this._buildBaseMessage("".concat(ERROR, ":").concat(this._buildStringFromError(error))) : this._buildBaseMessage("".concat(ERROR, ":").concat(error));
    }
  }, {
    key: "buildMessage",
    value: function buildMessage(level, _ref3) {
      var attributes = _ref3.attributes;
      for (var _len2 = arguments.length, payload = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        payload[_key2 - 2] = arguments[_key2];
      }
      var msg = this._buildPayloadIntoString.apply(this, payload);
      if (!level) {
        return "".concat(this._buildAttributes(attributes)).concat(msg);
      }
      switch (level) {
        case ERROR:
          return this.buildErrorMessage(msg);
        case WARNING:
          return this.buildWarningMessage(msg);
        case INFO:
          return this.buildInfoMessage(msg);
        case DEBUG:
          return this.buildDebugMessage(msg);
      }
    }
  }]);
}();
var instance = new MessagePresenter();
exports = module.exports = instance;